<template>
  <v-flex data-qa="debitcard-flex-te7hw">
    <Loader v-show="loaderEnabled" />
    <v-layout wrap class="ml-2 pt-0" data-qa="debitcard-layout-pa4vsq">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="debitcard-flex-lf41rj">
        <v-container data-qa="debitcard-container-b9enib">
          <v-flex xs12 sm12 md12 lg12 xl12 class="px-2" data-qa="debitcard-flex-2dq7sx">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="debitcard-flex-o3wcda">
              <v-row no-gutters class="pb-2" data-qa="debitcard-row-y32r9o">
                <inline-svg
                  class="mt-2"
                  :src="getNavigationIcon()"
                  width="50"
                  height="50"
                  aria-label="Navigation Icon"
                ></inline-svg>
                <font class="display-1 font-weight-thin white--text pt-4 pl-2">
                  {{ $t("common.debitLabel") }} ({{
                    debitCard.accounts.length
                  }})</font
                >
              </v-row>
            </v-flex>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="debitcard-flex-3ezql">
      <v-flex xs6 sm6 md6 lg4 xl4 class="pl-1 mt-4" v-if="(isSmeLogin && !$route.params.accountNumber)" data-qa="debitcard-flex-p67add">
        <v-select
          @change="filterAccountNumbers(accountFilter)"
          small
          v-model="accountFilter"
          :items="accountNumbers"
          outlined
          dense
         data-qa="debitcard-select-frdns"></v-select>
      </v-flex>
      <CardLayout :config="debitCard" />
    </v-flex>
  </v-flex>
</template>

<script>
import _ from 'lodash'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import CardLayout from '@/views/home/HomeCards.vue'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'Debit',
  components: {
    Loader,
    CardLayout
  },
  data () {
    return {
      accountType: '',
      loaderEnabled: false,
      debitCard: {
        title: this.$t('common.debitTypeLabel'),
        cardLabels: false,
        openNewACCard: false,
        accounts: [],
        enableShowMore: false
      },
      allAccounts: [],
      accDetails: {
        myBalance: 0,
        currency: '',
        series: []
      },
      baseCurrency:
        this.$appSettings.defaultConfigurations.currencyFormat.currency,
      enableOpenNewAccountOption:
        this.$appSettings.defaultConfigurations.enableOpenNewAccountOption,
      accountNumbers: [],
      accountFilter: '0',
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin'))
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  created () {
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.debitCard.enableShowMore = true
    } else this.debitCard.enableShowMore = false
    event.$on('set_myAccounts', () => {
      if (this.$route.params.accountNumber) {
        this.getListOfAccounts(this.$route.params.accountNumber)
      } else {
        this.getListOfAccounts()
      }
      this.loaderEnabled = false
    })
    if (this.$route.params.accountNumber) {
      this.getListOfAccounts(this.$route.params.accountNumber)
    } else {
      if (this.ifMyAccountsAvailable()) {
        this.getListOfAccounts()
      } else {
        this.loaderEnabled = true
        preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
      }
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Savings_1')
    },
    goToOffer (type) {
      this.$router.push({
        name: 'Card Products',
        params: { accountType: type }
      })
    },
    getListOfAccounts (accountId) {
      this.loaderEnabled = true
      if (accountId) {
        const data = store.getters['userStore/userData'].myAccounts
        if (data) {
          this.debitCard.accounts = data.debitCards
            ? data.debitCards.accountList
            : []
          this.allAccounts = data.debitCards ? data.debitCards.accountList : []

          if (this.debitCard.accounts.length) {
            this.filterAccountNumbers(accountId)
          }
        }
      } else {
        const data = store.getters['userStore/userData'].myAccounts
        if (data) {
          this.debitCard.accounts = data.debitCards
            ? data.debitCards.accountList
            : []
          this.allAccounts = data.debitCards ? data.debitCards.accountList : []
          if (this.debitCard.accounts.length) {
            this.debitCard.accounts = _.filter(
              this.debitCard.accounts,
              (account) => {
                return !this.$appSettings.uiFieldsDisplayConfigurations.debitCardsListing.exclusionList.includes(
                  account.cardStatus
                )
              }
            )
          }
        }
      }
      if (this.isSmeLogin && !this.$route.params.accountNumber) {
        this.debitCard.accounts.forEach((account) =>
          this.accountNumbers.push(account.accountNumber)
        )
        if (this.accountNumbers.length > 0) {
          this.accountFilter = this.accountNumbers[0]
          this.filterAccountNumbers(this.accountFilter)
        }
      }

      this.loaderEnabled = false
    },
    fetchAccounts () {
      this.loaderEnabled = true
      const accounts = store.getters['userStore/userData'].myAccounts
      const debitCards = accounts.debitCard
        ? accounts.debitCard.accountList
        : []
      if (debitCards && debitCards.length) {
        this.debitCard.accounts = []
        const excludeAccountStatus = ['BLOCKED', 'STOPPED']
        for (const i in debitCards) {
          if (excludeAccountStatus.includes(debitCards[i].accountStatus)) {
            debitCards[i].balance = this.$t('myAccounts.notAvailableLabel')
          } else {
            if (!isNaN(debitCards[i].balance)) {
              debitCards[i].balance = this.getBalInfo(debitCards[i].balance)
            } else {
              if (
                !debitCards[i].balance &&
                debitCards[i].accountStatus === 'ACTIVATED'
              ) {
                debitCards[i].balance = this.$t(
                  'myAccounts.balanceInquiryRestricted'
                )
              }
            }
          }
          this.debitCard.accounts.push({
            ...debitCards[i],
            status: this.$t(`systemEnums.casa.${debitCards[i].accountStatus}`),
            accountNumber: debitCards[i].accountId
          })
        }
        this.loaderEnabled = false
      } else {
        this.loaderEnabled = false
      }
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].myAccounts
    },
    getBalInfo (bal) {
      if (bal !== undefined && bal.toString().trim().length > 0) {
        if (isNaN(bal)) {
          return bal
        } else {
          return this.$formatter.currency.format(bal)
        }
      } else {
        return this.$t('myAccounts.notAvailableLabel')
      }
    },
    filterAccountNumbers (accountNumber) {
      this.debitCard.accounts = _.filter(this.allAccounts, [
        'accountNumber',
        accountNumber
      ])
    }
  }
}
</script>
